// Gallery images for Mirage Foods

export const galleryImages = [
  {
    id: 1,
    src: '/images/gallery/gelato-hero.jpg',
    alt: 'Mirage Gelato'
  },
  {
    id: 2,
    src: '/images/gallery/dessert-plate-1.jpeg',
    alt: 'Gourmet Dessert Plate'
  },
  {
    id: 3,
    src: '/images/gallery/devils-food.jpg',
    alt: 'Devil\'s Food Cake'
  },
  {
    id: 4,
    src: '/images/gallery/creme-brulee.jpg',
    alt: 'Crème Brûlée'
  },
  {
    id: 5,
    src: '/images/gallery/chocolate-mousse.jpg',
    alt: 'Chocolate Mousse'
  },
  {
    id: 6,
    src: '/images/gallery/choco-cake.jpg',
    alt: 'Chocolate Cake'
  },
  {
    id: 7,
    src: '/images/gallery/whipped-cream.jpg',
    alt: 'Whipped Cream'
  },
  {
    id: 8,
    src: '/images/gallery/french-custard-tart.jpeg',
    alt: 'French Custard Tart'
  },
  {
    id: 9,
    src: '/images/gallery/matcha-desserts.jpeg',
    alt: 'Matcha Cream Desserts'
  },
  {
    id: 10,
    src: '/images/gallery/opera-cake-matcha.jpeg',
    alt: 'Opera Cake with Matcha'
  },
  {
    id: 11,
    src: '/images/gallery/chef-creating-dessert.jpeg',
    alt: 'Chef Creating Dessert'
  },
  {
    id: 12,
    src: '/images/gallery/dessert-plate-large.jpeg',
    alt: 'Elegant Dessert Presentation'
  }
];
